export default [
    {
        path: "/admin-sheet-roll/:id",
        component: () => import("@/App/Admin/SheetRoll/Components/SheetRoll.vue"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "basic",
                component: () => import("@/App/Admin/SheetRoll/Components/Basic.vue"),
                name: "admin-sheet-roll-basic",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "address",
                component: () => import("@/App/Admin/SheetRoll/Components/Address.vue"),
                name: "admin-sheet-roll-address",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "sheet-roll-details",
                component: () => import("@/App/Admin/SheetRoll/Components/Details.vue"),
                name: "admin-sheet-roll-details",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "education",
                component: () => import("@/App/Admin/SheetRoll/Components/Education.vue"),
                name: "admin-sheet-roll-education",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "admission-training-information",
                component: () => import("@/App/Admin/SheetRoll/Components/Training.vue"),
                name: "admin-sheet-roll-admission-training-information",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "training-sheet",
                component: () => import("@/App/Admin/SheetRoll/Components/TrainingSheet.vue"),
                name: "admin-sheet-roll-training-sheet",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "appointments",
                component: () => import("@/App/Admin/SheetRoll/Components/Recruitments.vue"),
                name: "admin-sheet-roll-appointments",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "special-qualifications",
                component: () => import("@/App/Admin/SheetRoll/Components/SpecialQualification.vue"),
                name: "admin-sheet-roll-special-qualifications",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "annual-confidential-report",
                component: () => import("@/App/Admin/SheetRoll/Components/ConfidentialReport.vue"),
                name: "admin-sheet-roll-annual-confidential-report",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-casual-event-transfers",
                component: () => import("@/App/Admin/SheetRoll/Components/GeneralCasualEventTransfers.vue"),
                name: "admin-sheet-roll-general-casual-event-transfers",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-promotion-demotion-stabilization",
                component: () => import("@/App/Admin/SheetRoll/Components/GeneralCasualEventsPromotions.vue"),
                name: "admin-sheet-roll-general-promotion-demotion-stabilization",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-medical-matter",
                component: () => import("@/App/Admin/SheetRoll/Components/GeneralMedicalMatter.vue"),
                name: "admin-sheet-roll-general-medical-matter",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "general-event-other",
                component: () => import("@/App/Admin/SheetRoll/Components/GeneralEventOther.vue"),
                name: "admin-sheet-roll-general-event-other",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "behavior-description",
                component: () => import("@/App/Admin/SheetRoll/Components/BehaviorDescription.vue"),
                name: "admin-sheet-roll-behavior-description",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "behavior-description-warning",
                component: () => import("@/App/Admin/SheetRoll/Components/BehaviorDescriptionWarning.vue"),
                name: "admin-sheet-roll-behavior-description-warning",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "overseas-jobs-honors",
                component: () => import("@/App/Admin/SheetRoll/Components/OverseasJobsHonors.vue"),
                name: "admin-sheet-roll-overseas-jobs-honors",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "annual-leave",
                component: () => import("@/App/Admin/SheetRoll/Components/AnnualLeave.vue"),
                name: "admin-sheet-roll-annual-leave",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "recreation-leave",
                component: () => import("@/App/Admin/SheetRoll/Components/RecreationLeave.vue"),
                name: "admin-sheet-roll-recreation-leave",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "salary-increase",
                component: () => import("@/App/Admin/SheetRoll/Components/SalaryIncrease.vue"),
                name: "admin-sheet-roll-salary-increase",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "allowances",
                component: () => import("@/App/Admin/SheetRoll/Components/Allowances.vue"),
                name: "admin-sheet-roll-allowances",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "other-allowances",
                component: () => import("@/App/Admin/SheetRoll/Components/OtherAllowances.vue"),
                name: "admin-sheet-roll-other-allowances",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "loans-deductions",
                component: () => import("@/App/Admin/SheetRoll/Components/LoansDeductions.vue"),
                name: "admin-sheet-roll-loans-deductions",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "army-family-security",
                component: () => import("@/App/Admin/SheetRoll/Components/ArmyFamilySecurity.vue"),
                name: "admin-sheet-roll-army-family-security",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "nominated-names",
                component: () => import("@/App/Admin/SheetRoll/Components/NominatedNames.vue"),
                name: "admin-sheet-roll-nominated-names",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "army-health-insurance",
                component: () => import("@/App/Admin/SheetRoll/Components/ArmyHealthInsurance.vue"),
                name: "admin-sheet-roll-army-health-insurance",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "inactive-statement-account",
                component: () => import("@/App/Admin/SheetRoll/Components/InactiveStatementAccount.vue"),
                name: "admin-sheet-roll-inactive-statement-account",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "reserved-soldiers",
                component: () => import("@/App/Admin/SheetRoll/Components/ReservedSoldiers.vue"),
                name: "admin-sheet-roll-reserved-soldiers",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "nearest-relatives",
                component: () => import("@/App/Admin/SheetRoll/Components/NearestRelatives.vue"),
                name: "admin-sheet-roll-nearest-relatives",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "death-account",
                component: () => import("@/App/Admin/SheetRoll/Components/DeathAccount.vue"),
                name: "admin-sheet-roll-death-account",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "department-defense-finance",
                component: () => import("@/App/Admin/SheetRoll/Components/DepartmentDefenseFinance.vue"),
                name: "admin-sheet-roll-department-defense-finance",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "personal-information",
                component: () => import("@/App/Admin/SheetRoll/Components/PersonalInformation.vue"),
                name: "admin-sheet-roll-personal-information",
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "characteristic",
                component: () => import("@/App/Admin/SheetRoll/Components/Characteristic.vue"),
                name: "admin-sheet-roll-characteristic",
                meta: {
                    requiresAuth: true,
                },
            },

            {
                path: "files",
                component: () => import("@/App/Admin/SheetRoll/Components/Files.vue"),
                name: "admin-sheet-roll-files",
                meta: {
                    requiresAuth: true,
                },
            },
        ],
    },
];
